<template>
  <div id="loginbox" style="margin-top:50px;" class="mainbox col-md-4 col-md-offset-4">
    <div class="panel panel-info">
      <div class="panel-heading">
        <div class="panel-title">Вход</div>
      </div>
      <div style="padding-top:30px" class="panel-body">
        <div class="alert alert-danger col-sm-12" v-if="errtext">{{errtext}}</div>
        <form class="form-horizontal" role="form" @submit.prevent="login()">
          <div style="margin-bottom: 25px" class="input-group">
            <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
            <input
              id="login-username"
              type="text"
              class="form-control"
              name="username"
              v-model="username"
              placeholder="LOGIN">
          </div>
          <div style="margin-bottom: 25px" class="input-group">
            <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
            <input
              id="login-password"
              type="password"
              class="form-control"
              name="password"
              v-model="password"
              placeholder="PASSWORD">
          </div>
          <div style="margin-top:10px" class="form-group">
            <div class="col-sm-12 controls">
              <button type="submit" class="btn btn-success">Вход</button>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12 control">
              <div style="border-top: 1px solid#888; padding-top:15px; font-size:85%">
                Вход в систему!
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from './http'

export default {
  name: 'Login',
  created () {
    if (localStorage.getItem('user')) {
      window.location.href = '/#/'
      window.location.reload()
    }
  },
  data () {
    return {
      username: '',
      password: '',
      errtext: ''
    }
  },
  methods: {
    login () {
      api.post('session/login', this.prepPost({
        email: this.username,
        password: this.password
      })).then(res => {
        if (res.data.token) {
          this.errtext = ''
          localStorage.setItem('user', true)
          localStorage.setItem('token', res.data.token)
          window.location.href = '/#/'
          window.location.reload()
        } else {
          this.errtext = `Неверны логин или пароль`
        }
      }).catch(() => {
        this.errtext = `Неверны логин или пароль`
      })
    },
    prepPost (data) {
      var formData = new FormData()
      for (let key in data) {
        if (Array.isArray(data[key])) {
          for (let i in data[key]) {
            formData.append(key + '[]', data[key][i])
          }
        } else {
          let val = data[key] || ''
          formData.append(key, val)
        }
      }
      return formData
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue